//#region redux
import { useDispatch } from "react-redux";
import { supportSnoozed } from "store/actions/supportActions";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";
import { LocalizationHelperInstance } from "utils/helpers";

function useMessageSnoozeAction(id: number | string, reloadHandler: () => void) {
  const dispatch = useDispatch();

  const onSnoozeMessageSuccess = () => {
    reloadHandler();
    dispatch(supportSnoozed(id as number));
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.Support,
    onSnoozeMessageSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Support)
  );

  return snoozeAction;
}

export default useMessageSnoozeAction;
